var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "auth-layout",
    { attrs: { pageClass: "login-page" } },
    [
      _c(
        "b-row",
        { staticClass: "d-flex justify-content-center align-items-center" },
        [
          _c("b-col", { attrs: { lg: "4", md: "6", sm: "8" } }, [
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit($event)
                  }
                }
              },
              [
                _c(
                  "fade-render-transition",
                  [
                    _c("card", [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("h3", { staticClass: "card-title text-center" }, [
                          _vm._v("Forgot Password")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("fg-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            class: _vm.errors.has("email") ? "is-invalid" : "",
                            attrs: {
                              label: "Email",
                              placeholder: "Enter email",
                              type: "email",
                              autofocus: "",
                              name: "email"
                            },
                            model: {
                              value: _vm.model.email,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "email", $$v)
                              },
                              expression: "model.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn-fill btn-round btn-wd ",
                              attrs: { variant: "success", type: "submit" }
                            },
                            [
                              _vm.isLoading
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "spinner", spin: "" }
                                  })
                                : _vm._e(),
                              _vm._v(" Send Reset Link")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "forgot" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "card-category",
                                  attrs: { to: "/login" }
                                },
                                [
                                  _vm._v(
                                    "\n                  Back To Log In\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58d06d0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58d06d0b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Auth/ForgotPassword.vue
// module id = 0cxR
// module chunks = 4